const articles = {};

var loadMoreButton = false;

articles.init = () => {
  // Article Ajax Load More Start Here
  loadMoreButton = $( '.article-loadmore' );

  loadMoreButton.on( 'click', function () {
    var currentPage = $( this ).data( 'currentpage' );
    var nextPage = currentPage + 1;
    articleLoad( nextPage );
    $( this ).data( 'currentpage', nextPage );
  } );
}

articles.init();

function articleLoad ( nextPage ) {
  var ajaxUrl = loadMoreButton.data( 'ajaxurl' );
  var order = loadMoreButton.data( 'order' );
  var orderBy = loadMoreButton.data( 'orderby' );
  var postsPerPage = loadMoreButton.data( 'postsperpage' );
  var currentTermId = loadMoreButton.data( 'currentterm_id' );
  var languange = loadMoreButton.data('language');
  // /wp-json/wp/v2/posts?per_page=10&page=1&categories=4,5&order=desc&order_by=post_date
  ajaxUrl += '?page=' + nextPage;
  ajaxUrl += '&per_page=' + postsPerPage;

  if(currentTermId) {
    ajaxUrl += '&categories=' + currentTermId;
  }

  // ajaxUrl += '&categories_exclude=1';
  ajaxUrl += '&order=' + order;
  ajaxUrl += '&order_by=' + orderBy;
  ajaxUrl += '&lang=' + languange;
  // console.log(ajaxUrl);
  $.ajax( {
    url: ajaxUrl,
    type: 'GET',
    beforeSend: function () {
      loadMoreButton.addClass( 'is-loading' );
    },
    error: function ( data, textStatus ) {
      console.log( data );
      console.log( textStatus );
    },
    success: function ( data, textStatus, jqXHR ) {
      if ( data ) {
        loadMoreButton.removeClass( 'is-loading' );

        // Need to clear list if Filter is trigger
        if ( nextPage == 1 ) {
          $( '.article-list' ).html( '' );
        }

        if ( $( data ).length > 0 ) {
          $( data ).each( function ( key, val ) {
            $( '.article-list' ).append( val.article_item );
          } );
        }

        var totalCount = parseInt( jqXHR.getResponseHeader( 'X-WP-Total' ), 10 );
        // if ($('.js-total-count')) {
        // 	$('.js-total-count').text( totalCount );
        // }

        if ( totalCount === 0 ) {
          loadMoreButton.addClass( 'd-none' );
        }

        var totalPage = parseInt( jqXHR.getResponseHeader( 'X-WP-TotalPages' ), 10 );
        if ( loadMoreButton.data( 'currentpage' ) == totalPage || data.length == 0 )
          loadMoreButton.addClass( 'd-none' ); // if last page, remove the button
      } else {
        loadMoreButton.addClass( 'd-none' ); // if no data, remove the button as well
      }
    },
    complete: function () {
      if ( window.lazyLoadInstance ) {
        window.lazyLoadInstance.update();
      }
    },
  } );
}


// WEBPACK FOOTER //
// ./scripts/components/articles.js